import { appendDisplayMagnitudePostfix } from '@lib/util/display-magnitude';
import { DebouncedField } from '@ui/components/DebouncedField';
import { DollarSignIcon } from '@ui/components/Icons';
import { selectQuoteBuilder } from '@ui/features/quote-builder/state/selectors/quote-builder';
import { selectQuotePriceField } from '@ui/features/quote-builder/state/selectors/quote-price-field';
import { useDispatch } from '@ui/hooks/useDispatch';
import { useSelector } from '@ui/hooks/useSelector';

import { actions } from '../../state/reducer';
import { useQuotePriceContext } from './QuotePriceProvider';

export function EditableUnitCost() {
  const dispatch = useDispatch();
  const displayQuantity = useSelector(
    (state) => selectQuoteBuilder(state).displayQuantity,
  );
  const { quoteLineUuid, quotePriceUuid, isFirstQuotePrice } =
    useQuotePriceContext();

  const { elementId, value, issues } = useSelector((state) =>
    selectQuotePriceField(state, quoteLineUuid, quotePriceUuid, 'unitCost'),
  );

  function handleChange(unitCost: string) {
    dispatch(
      actions.unitCostChanged({
        quoteLineUuid,
        quotePriceUuid,
        value: unitCost,
      }),
    );
  }

  return (
    <DebouncedField
      label={appendDisplayMagnitudePostfix('Unit Cost', displayQuantity, '/')}
      id={elementId}
      showLabel={isFirstQuotePrice}
      leftIcon={DollarSignIcon}
      value={value}
      onChange={handleChange}
      inputMode="numeric"
      isInvalid={issues.length > 0}
      error={issues[0]?.description}
    />
  );
}
